import {
  Component,
  h,
  Host,
  Listen,
  Prop,
  State,
  Event,
  Element,
  EventEmitter,
} from '@stencil/core';
import { QwModalBaseInfo } from '../../index';
import { Language } from '@cesare';
import { IS_MOBILE, stopBodyScroll } from '../../global/app';

const VIENNA_HOTEL_ID = 25272;
@Component({
  tag: 'qw-modal-room-details',
  styleUrl: 'qw-modal-room-details.scss',
  shadow: false,
})
export class QwRoomBasket {
  @Prop() qwRoomData?: QwModalBaseInfo | false;
  @Prop() modalWrapper: HTMLElement;
  @Element() el: HTMLElement;
  @State() qwIsOpen: boolean = false;
  @Event() qwEmitCloseModalRoomDetails: EventEmitter;

  public componentDidLoad() {
    this.el.addEventListener('click', this.handleOutsideClick);
  }

  handleOutsideClick = (event: MouseEvent) => {
    if (
      this.qwIsOpen &&
      !this.el
        .querySelector('.qw-room-list-card__details-popup-content')
        .contains(event.target as Node)
    ) {
      this.qwIsOpen = false;
      this.qwRoomData = false;
      this.qwEmitCloseModalRoomDetails.emit();
      stopBodyScroll(this.qwIsOpen);
    }
  };

  @Listen('qwEmitRoomDetail', { target: 'window' })
  public roomDetailData(e: CustomEvent<QwModalBaseInfo>) {
    this.qwRoomData = e.detail;
    this.qwIsOpen = true;
    stopBodyScroll(this.qwIsOpen);
  }

  private formatRoomListCardServices() {
    if (!this.qwRoomData) return;
    const services = this.qwRoomData.services.map((s) => s.amenities);
    return services.reduce((acc, val) => acc.concat(val), []);
  }

  private shouldShowBlindsIconEquipment() {
    if (!this.qwRoomData) return;
    const isSingleBed = Number(this.qwRoomData.roomCardBedding) === 1;
    return !!(
      this.qwRoomData.cardSessionHotelId === VIENNA_HOTEL_ID && isSingleBed
    );
  }

  render() {
    return (
      <Host class={`qw-modal ${this.qwIsOpen ? 'is-open' : ''}`}>
        {this.qwRoomData && (
          <div class="qw-room-list-card__details-popup-wrapper">
            <div class="qw-room-list-card__details-popup-content">
              <span
                class="close-icon"
                onClick={() => {
                  this.qwIsOpen = false;
                  this.qwRoomData = false;
                  this.qwEmitCloseModalRoomDetails.emit();
                  stopBodyScroll(this.qwIsOpen);
                }}
              />
              <div class="content-info">
                <h2>{this.qwRoomData.title}</h2>
                <p innerHTML={this.qwRoomData.description} />
                <div class="content-info__services">
                  <ul class="qw-room-base-info-list qw-room-list-card--services">
                    {this.qwRoomData &&
                      this.qwRoomData.services &&
                      this.formatRoomListCardServices().map((s) => {
                        return (
                          <li
                            class={`qw-room-base-info__item qw-room-base-info__item--${s.value}`}
                          >
                            <span class="icon" />
                            <p>{s.text}</p>
                          </li>
                        );
                      })}
                    {this.qwRoomData &&
                      this.shouldShowBlindsIconEquipment() && (
                        <li
                          class={`qw-room-base-info__item qw-room-base-info__item--blinds`}
                        >
                          <span class="icon" />
                          <p>
                            {Language.getTranslation('blindsOnLowerBunkbeds')}
                          </p>
                        </li>
                      )}
                  </ul>
                </div>
              </div>
              <div class="content-carousel">
                {(!this.qwRoomData.showCarousel ||
                  this.qwRoomData.images.length === 1) && (
                  <qw-image
                    qwImageTransformationOptions={
                      this.qwRoomData.transformationOptions
                    }
                    qwImageUrl={this.qwRoomData.image}
                    qwImageAlt={this.qwRoomData.title}
                  />
                )}
                {this.qwRoomData.showCarousel &&
                  this.qwRoomData.images &&
                  this.qwRoomData.images.length > 1 && (
                    <qw-carousel
                      qwCarouselImagesUrl={this.qwRoomData.images}
                      width={IS_MOBILE ? 500 : 648}
                      height={IS_MOBILE ? 375 : 486}
                    ></qw-carousel>
                  )}
              </div>
            </div>
          </div>
        )}
      </Host>
    );
  }
}
